import React from 'react';

import {Stack} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {ConfirmationCTAButtonsProps} from './types';
import {CTAButtonFixed} from 'presentation/components';
import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';

const {seeMyAppointments, confirmationPage} = translations['pt-br'].privateFlow.bookingFlow;

export function ConfirmationCTAButtons({
	goToMyAppointments,
	goToHome,
	isMobile,
}: ConfirmationCTAButtonsProps) {
	return (
		<CTAButtonFixed.Root>
			<Stack
				gap={1}
				direction={isMobile ? 'column-reverse' : 'row'}
				justifyContent="flex-end">
				<CTAButtonFixed.Action
					data-tag-id={OdontoBookingTaggingEnum.CLICK_VOLTAR_STEP_CONFIRMAR_AGENDAMENTO}
					fullWidth={isMobile}
					onClick={goToHome}
					size="large"
					variant="outlined">
					{confirmationPage.goToHome}
				</CTAButtonFixed.Action>
				<CTAButtonFixed.Action
					data-tag-id={OdontoBookingTaggingEnum.CLICK_VER_MEUS_AGENDAMENTOS}
					fullWidth={isMobile}
					onClick={goToMyAppointments}
					size="large">
					{seeMyAppointments}
				</CTAButtonFixed.Action>
			</Stack>
		</CTAButtonFixed.Root>
	);
}
